import React from "react";
import TimesCard from './card';
import { message } from "antd";
import { getCurrentShopId } from "../../shop/get-current-shop";

export default () => {
    const [content, setContent] = React.useState({});
    const params = new URLSearchParams(window.location.search);
    const cardId = params.get('cardId');
    const [shopId, setShopId] = React.useState(null);

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
            params.set('shopId', id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId && cardId) {
            getContent(cardId, shopId).then(res => {
                if(res) {
                    setContent(res);
                }
            })
        }
    }, [shopId, cardId]);

    const getContent = async (cardId, shopId) => {
        if (!shopId) return;
        
        const res = await fetch(`/api/goods-card/card-detail?cardId=${cardId}&shopId=${shopId}`);
        const result = await res.json();

        if(result?.success) {
            return result.data;
        }else {
            message.error(result.data);
        }
    }

    return (
        <div>
            <h2>次卡详情</h2>
            <TimesCard content={content} />
        </div>
    );
}